import { invalid } from 'moment';

export const AppConfig = {
  apiHost: `${window.ENV.API_HOST}/`,
  logLevel: window.ENV.LOG_LEVEL,
  googleAPIKey: window.ENV.GOOGLE_API_KEY,
  healthlineUrl: window.ENV.HEALTHLINE_URL,
  contactUsUrl: window.ENV.CONTACT_US_URL,
  privacyUrl: window.ENV.PRIVACY_URL,
  helpUrl: window.ENV.HELP_URL,
  gaTrackingId: window.ENV.GA_TRACKING_ID,
  feedbackUrl: window.ENV.FEEDBACK_URL,
  baseHubUrl: window.ENV.BASE_HUB_URL,
  baseEconUrl: window.ENV.BASE_ECON_URL,
  baseGuestServeUrl: window.ENV.BASE_GUEST_URL,
  baseSelfServeUrl: window.ENV.BASE_SELF_SERVE_URL,
  baseScheduleUrl: window.ENV.BASE_SCHEDULE_URL,
  baseTeledermUrl: window.ENV.BASE_TELEDERM_URL,
  baseEvisitUrl: window.ENV.BASE_EVISIT_URL,
  baseSofLaunchUrl: window.ENV.BASE_SMARTONFHIR_URL,
  inactiveEconsultServiceUrl: window.ENV.INACTIVE_ECONSULT_SERVICE_URL
};
